<template>
  <div class="c-panel__body">
    <div class="o-layout o-layout--responsive">
      <div class="o-layout__item u-txt--fair u-txt--bold u-mrgn-bottom--3 qa-product-info-panel">
        Detail Reksa Dana
      </div>
      <div class="u-txt--base u-clearfix u-mrgn-bottom--4">
        <div
          v-for="(info, index) in Object.keys(infoList)"
          :key="index"
          class="o-layout__item u-pad-left--0 u-mrgn-bottom--1"
        >
          <div class="o-layout__item u-6of12 u-fg--ash-dark">
            {{ info }}
          </div>
          <div v-if="infoList[info] !== 'Syariah'" class="o-layout__item u-6of12">
            {{ infoList[info] }}
          </div>
          <div v-else class="o-layout__item u-6of12">
            <a href="/bukareksa/reksa-dana-syariah" data-no-turbolink="true"> {{ infoList[info] }} </a>
          </div>
        </div>
      </div>
      <div class="o-layout__item u-txt--base u-mrgn-bottom--3">
        <div class="u-txt--bold u-mrgn-bottom--1">Alokasi Portofolio ({{ assetAllocationDate }})</div>
        <ul class="asset-allocation">
          <li v-for="(asset, index) in assetAllocation" :key="index">
            {{ asset }}
          </li>
        </ul>
      </div>
      <div class="o-layout__item u-txt--base u-mrgn-bottom--4">
        <div class="u-txt--bold u-mrgn-bottom--1">
          Tujuan Investasi
        </div>
        <div>{{ investmentGoals }}</div>
      </div>
      <div class="o-layout__item u-txt--base">
        Baca <a class="u-fg--red-brand" :href="prospectusUrl">Prospektus</a> dan
        <a class="u-fg--red-brand" :href="fundFactSheetUrl">Keterangan Ringkas</a>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { money } from 'shared/helpers/numberHelper';

export default {
  name: 'ProductInfo',
  props: {
    assetAllocationDate: {
      type: String,
      default: '',
    },
    assetAllocation: {
      type: Array,
      default: () => [],
    },
    launchDate: {
      type: String,
      default: '',
    },
    custodianBankName: {
      type: String,
      default: '',
    },
    subscriptionLimit: {
      type: Number,
      default: 0,
    },
    nextSubscriptionLimit: {
      type: Number,
      default: 0,
    },
    investmentGoals: {
      type: String,
      default: '',
    },
    prospectusUrl: {
      type: String,
      default: '',
    },
    fundFactSheetUrl: {
      type: String,
      default: '',
    },
    syariah: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    infoList() {
      return {
        'Tanggal Peluncuran': dayjs(this.launchDate).format('DD MMMM YYYY'),
        'Bank Kustodian': this.custodianBankName,
        'Minimum Pembelian Awal': money(this.subscriptionLimit),
        'Minimum Pembelian Selanjutnya': money(this.nextSubscriptionLimit),
        'Prinsip Pengelolaan': this.syariah ? 'Syariah' : 'Konvensional',
      };
    },
  },
};
</script>

<style scoped>
.asset-allocation {
  list-style-type: disc;
  list-style-position: outside;
  margin-left: 18px;
}
.asset-allocation > li {
  padding-left: 12px;
}
</style>
